import { Map } from 'immutable';
import { ApiResponseHelper } from 'omni-common-ui';
import {
  FETCH_STUDENT_REPORT_SUMMARY_SUCCESS,
  FETCH_STUDENT_REPORT_SUMMARIES_REQUEST,
  FETCH_STUDENT_REPORT_SUMMARIES_SUCCESS,
  FETCH_STUDENT_REPORT_SUMMARIES_FAILURE,
} from './actions';

import StudentReportSummary from './model';

export default function studentReportSummaryReducer(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_STUDENT_REPORT_SUMMARIES_REQUEST:
      return state.set(action.progressReportId,
          ApiResponseHelper.create({ loading: true }));
    case FETCH_STUDENT_REPORT_SUMMARY_SUCCESS:
      return addStudentSummaryToMap(state, action);
    case FETCH_STUDENT_REPORT_SUMMARIES_SUCCESS:
      return addStudentSummariesToMap(state, action);
    case FETCH_STUDENT_REPORT_SUMMARIES_FAILURE:
      return state.set(action.progressReportId,
        ApiResponseHelper.create(action.error));
    default:
      return state;
  }
}

function addStudentSummariesToMap(state, { payload, progressReportId }) {
  let newState = state;
  let studentSummaries = new Map();
  payload.forEach((studentReportSummary) => {
    const studentReportSummaryModel = StudentReportSummary.create(studentReportSummary);
    studentSummaries = studentSummaries.set(`${studentReportSummaryModel.studentId}`,
      studentReportSummaryModel);
  });
  newState = newState.set(progressReportId, ApiResponseHelper.create(studentSummaries));
  return newState;
}

function addStudentSummaryToMap(state, { payload, progressReportId, studentId }) {
  let newState = state;
  const studentReportSummaryModel = StudentReportSummary.create(payload);
  if (newState.get(progressReportId) && newState.get(progressReportId).data) {
    newState = newState.get(progressReportId).data.set(studentId, studentReportSummaryModel);
  } else {
    let studentSummaries = new Map();
    studentSummaries = studentSummaries.set(`${studentReportSummaryModel.studentId}`,
    studentReportSummaryModel);
    newState = newState.set(progressReportId, ApiResponseHelper.create(studentSummaries));
  }

  return newState;
}



// WEBPACK FOOTER //
// ./data/ProgressReports/StudentReportSummaries/reducer.js